import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  constructor(private firestore:AngularFirestore) { }
  product;

  getProducts(){
    console.log(this.firestore.collection('products').snapshotChanges());
    return this.firestore.collection('products').snapshotChanges();
  }
  getProduct(productId){
    this.product = this.firestore.doc('products/'+productId);
    return this.product.valueChanges();
    // return this.firestore.collection('products').doc(productId).snapshotChanges();
  }
}
